import { createBaseCRUDApi, createBaseFilesApi } from '@/api/base'
import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { LOGISTIC_URL } from './const'

export const LOGISTIC_DRIVER_URL = `${LOGISTIC_URL}-driver`
const errors = createBaseResponseErrors('водителя', 'водителей')

export const LogisticDriverApi = {
  ...createBaseCRUDApi(LOGISTIC_DRIVER_URL, errors),
  ...createBaseFilesApi(LOGISTIC_DRIVER_URL)
}
